import styled from "styled-components"

import {CommonProps, commonCSS} from "../common"

import {mainStyles, boldStyles, regularStyles, labelWhite} from "./styles"

export interface InputProps extends CommonProps {
  bold?: boolean
  id?: string
  white?: boolean
}

export default styled.span<InputProps>`
  ${mainStyles}
  ${regularStyles} /* Default size, if no size prop is provided */

  ${({white}) => white && labelWhite}
  ${({bold}) => bold && boldStyles}

  ${commonCSS}
`
